import { Box, styled } from '@mui/material'

export const VideoSectionContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  height: '350px',
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    height: '400px',
  },
  [theme.breakpoints.up('md')]: {
    width: '60%',
    height: 'calc(100vh - 160px)',
    maxHeight: '580px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '65%',
    maxHeight: '780px',
  },
}))

export const VideoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'absolute',
  right: 0,
  zIndex: -1,
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    right: '-64px',
    width: '135%',
    height: '130%',
  },
}))
